import {
  SelectPopoverContextProvider,
  SelectPopoverContent,
  type SelectPopoverType,
} from "../../SelectPopover";
import { Drawer, type DrawerProps } from "../../Drawer";
import React from "react";
import styles from "./DataTableColumnConfigurationDrawer.module.scss";
import classNames from "classnames/bind";
import { LoadingState } from "../../LoadingState";

const cx = classNames.bind(styles);

export const DataTableColumnConfigurationDrawer = ({
  title = "Columns",
  isLoading = false,
  inputProps,
  ...restProps
}: Omit<DrawerProps, "children"> & {
  inputProps: SelectPopoverType;
  isLoading: boolean;
}) => {
  return (
    <SelectPopoverContextProvider {...inputProps}>
      <Drawer
        title={title}
        size="md"
        {...restProps}
      >
        <LoadingState
          isLoading={isLoading}
          label="Loading configuration"
        >
          <SelectPopoverContent className={cx("config-list")} />
        </LoadingState>
      </Drawer>
    </SelectPopoverContextProvider>
  );
};
